import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    question: 'Who needs to pay for the assessment?',
    answer: (
      <>
    Only the assessee needs to pay a nominal fee for the assessment. Organisations who choose to assess their value chain through our platform do not need to pay any fee.
      </>
    ),
  },
  {
    question: 'How long is the assessment valid?',
    answer: (
      <>
        The assessment report is valid for <strong>365 days</strong> from the day of generation on the website.
        All uploaded documents are stored for this same duration.
      </>
    ),
  },
  {
    question: 'Can one assessment serve multiple requesting companies?',
    answer: (
      <>
        Yes, if an assessee has multiple companies requesting them to undertake the assessment through Ethosflo,
        the assessment report will be sent to <strong>all the interested companies</strong> without requiring the
        assessee to undertake multiple assessments.
      </>
    ),
  },
  {
    question: 'What support is provided during the assessment?',
    answer: (
      <>
        A <strong>dedicated account manager</strong> is assigned to each assessee to provide guidance throughout
        the entire assessment process. Additional support includes document upload guidance, questionnaire
        assistance, and optional corrective action reports.
      </>
    ),
  },
  {
    question: 'How is data privacy ensured?',
    answer: (
      <>
        Our analysts are bound by <strong>legal agreements on data privacy</strong> and have limited access to the
        platform. The system is designed with strict access controls, and all sustainability professionals undergo
        training on data management and confidentiality.
      </>
    ),
  },
];

const Frequentlyaskedquestions = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
    id="frequentlyaskedquestions"
    className="bg-white text-black scroll-mt-16 py-16 px-6 sm:px-8 lg:px-16 flex items-center justify-center"
  >
     <div className="max-w-7xl mx-auto w-full flex flex-col space-y-12">
        <h2 className="text-3xl md:text-3xl font-bold text-center mb-4">
          Frequently Asked Questions
        </h2>

        {faqs.map((faq, index) => (
          <div key={index} className="border-b border-gray-300 pb-4">
            <button
              className="flex justify-between w-full text-left font-medium py-2 hover:text-teal-600 transition-colors"
              onClick={() => toggle(index)}
            >
              <span className="text-xl">{faq.question}</span>
              {openIndex === index ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>
            {openIndex === index && (
              <p className="text-xl mt-2 pl-4 border-l-4 border-teal-500 text-gray-700">
                {faq.answer}
              </p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Frequentlyaskedquestions;